/* eslint-disable import/prefer-default-export */
export const AUDIO_LIST_REMOVE_ANIMATE_TIME = 350;
